import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import ILocalState from './stateInterface';
import { GlobalOptions } from '@/enums/global/GlobalOptions';

const initState: ILocalState = {
    productForms: [],
    activeProductForms: [],
    offerRecalculationErrorItems: [],
    callbackAfterCalculation: null,
    recalculationAndCallbackLabel: '',
    offerErrorState: { existingError: false, existingWarning: false },
    defaultValueWarnings: [],
    customValuesOverride: [],
    offerPricesHaveErrors: false,
    isImportingColors: true,
    defaultPriceListRegionNameValue: GlobalOptions.DEFAULT_PRICELIST_VERSION as string,
};

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations,
};
